import { render, staticRenderFns } from "./EmailAutomation.vue?vue&type=template&id=2707ee3e&scoped=true&"
import script from "./EmailAutomation.vue?vue&type=script&lang=js&"
export * from "./EmailAutomation.vue?vue&type=script&lang=js&"
import style0 from "./EmailAutomation.vue?vue&type=style&index=0&id=2707ee3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707ee3e",
  null
  
)

export default component.exports